//* Components
import Filters from '../Filters';

//* Style
import LeftBarStyle from './style';

const LeftBar = ({ searchParams, filters, onFilterChange }) => {
	return (
		<LeftBarStyle>
			<Filters
				filters={filters}
				searchParams={searchParams}
				onFilterChange={onFilterChange}
			/>
		</LeftBarStyle>
	);
};

export default LeftBar;
